export default __webpack_public_path__ + "static/background-7-1dfb4ff388a3b72a62a7a7e4f400b2fc.png";